import {
  ActionIcon,
  Anchor,
  Button,
  Divider,
  Stack,
  Tooltip,
} from "@mantine/core";
import ListDownload from "../../../lists/actions/ListDownload";
import { downloadCampaign, editCampaign } from "../../../../../api/StatsAPI";
import PopOver from "../../../../../components/View/PopOver";
import {
  IconDotsVertical,
  IconEdit,
  IconEye,
  IconRepeat,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import UnarchiveCampaign from "./UnarchiveCampaign";
import ArchiveCampaign from "./ArchiveCampaign";
import { Link } from "react-router-dom";
import ToggleCampaign from "./ToggleCampaign";
import ItemSharer from "../../../../../components/TableComponents/ItemSharer";
import { editWorkflow } from "../../../../../api/WorkflowAPI";

const CampaignActions = ({ apiRef, current, onFinish, campaignFilter }) => {
  const lang = useLanguage((s) => s.language);
  
  const handleFinish = (closeMenu) => {
    closeMenu?.();

    setTimeout(() => {
      onFinish?.();
    }, 100);
  };

  return (
    <>
      <PopOver
        opener={(handleOpen, ref) => (
          <Tooltip label={lang.table.more_actions}>
            <ActionIcon
              variant="subtle"
              ref={ref}
              color="primary"
              onClick={handleOpen}
            >
              <IconDotsVertical size={18} />
            </ActionIcon>
          </Tooltip>
        )}
        popoverChildren={(handleClose) => (
          <Stack gap={0}>
            <ToggleCampaign apiRef={apiRef} current={current} />

            <ListDownload
              current={current}
              closeMenu={handleClose}
              handler={downloadCampaign}
              label={lang.campaigns.download_stats}
            />

            <Divider opacity={0.5} my={8} />

            <Button
              variant="subtle"
              component={Link}
              justify="start"
              to={`/campaign/edit/${current.id}/workflow/${current.workflow_id}?step=preview`}
              leftSection={<IconEye size={18} />}
            >
              {lang.campaigns.preview}
            </Button>

            <Button
              variant="subtle"
              disabled={!current.write_permission}
              component={Link}
              justify="start"
              to={
                !current.write_permission
                  ? null
                  : `/campaign/edit/${current.id}/workflow/${current.workflow_id}?step=program`
              }
              leftSection={<IconEdit size={18} />}
            >
              {lang.campaigns.edit}
            </Button>

            <Button
              variant="subtle"
              component={Link}
              justify="start"
              to={
                !current.write_permission
                  ? null
                  : `/campaign/edit/${current.id}/workflow/${current.workflow_id}?step=contacts&reprogram=true`
              }
              leftSection={<IconRepeat size={18} />}
            >
              {lang.workflows.reprog}
            </Button>

            {campaignFilter === "archived" ? (
              <UnarchiveCampaign
                apiRef={apiRef}
                current={current}
                onFinish={handleFinish}
                disabled={!current.write_permission}
              />
            ) : (
              <ArchiveCampaign
                apiRef={apiRef}
                current={current}
                onFinish={handleFinish}
                disabled={!current.write_permission}
              />
            )}
            <ItemSharer
              current={current}
              getEditFunction={(row) =>
                ({ id, sharing }) =>
                  editCampaign({
                    programmation_id: id,
                    workflow_id: row.workflow_id,
                    data: { stats_sharings: sharing },
                  }).then(() => {
                    return editWorkflow({
                      id: row.workflow_id,
                      sharing: sharing,
                    });
                  })}
              onFinish={onFinish}
            />
          </Stack>
        )}
        anchorOrigin={{ horizontal: "left", vertical: "center" }}
        transformOrigin={{ horizontal: "right", vertical: "center" }}
        sx={{ zIndex: "200 !important" }}
      />
    </>
  );
};

export default CampaignActions;
